var t = {
  OpenDialog: function OpenDialog() {
    var _document = document,
      t = _document.body,
      e = t.children,
      n = "undefined" != typeof document ? document.getElementById("tooltip-portal") : null;
    for (var _t = 0; _t < e.length; _t++) {
      var o = e[_t];
      o.setAttribute && o !== n && "SCRIPT" !== o.tagName && (o.setAttribute("data-old-aria-hidden", o.ariaHidden || "null"), o.setAttribute("aria-hidden", "true"));
    }
  },
  CloseDialog: function CloseDialog() {
    var _document2 = document,
      t = _document2.body,
      e = t.children;
    for (var _t2 = 0; _t2 < e.length; _t2++) {
      var n = e[_t2];
      n && (n.removeAttribute("data-old-aria-hidden"), n.removeAttribute("aria-hidden"), n.removeAttribute("inert"));
    }
  }
};
export { t as default };